/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/BoostDialog',['pixi', 'absolute', 'MenuUI/MsftModal', 'MenuUI/MsftButton', 'lodash', 'Arkadium/GameEngine/Core/EngineManagers', 'util/NineSliceButton', 'util/eventhandler', 'Managers/ScaleManager'],
	function (PIXI, Absolute, MsftModal, MsftButton, _, EngineManagers, NineSliceButton, EventHandler, ScaleManager) {

		var BoostDialog = function (parent, dialogHeadline, dialogBody, playAction, onClose) {
			this.onConfirm = new EventHandler();
			this.onCancel = new EventHandler();
			this.initBoostDialog(parent, dialogHeadline, dialogBody, playAction, onClose);
		};

		BoostDialog.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

		BoostDialog.prototype.initBoostDialog = function (parent, dialogHeadline, dialogBody, onClose) {
			PIXI.DisplayObjectContainer.call(this);
			this.layoutType = 'large';
			this.parentToAdd = parent;
			this.buildOverlay();
			this.parentToAdd.addChild(this);
			this.popupContainer = new PIXI.DisplayObjectContainer();
			var width = Absolute.Coords.x(1000),
				height = Absolute.Coords.y(350),
				graphics, icon, title, body,
				popupBkg = new PIXI.Graphics();
			popupBkg.beginFill(0xf4f4f4);
			popupBkg.drawRect(0, 0, width, height);
			popupBkg.endFill();
			graphics = new PIXI.Graphics();
			graphics.beginFill(0xfdfeff);
			graphics.lineStyle(5, 0xfdfeff);
			graphics.drawRect(0, 0, width, height);
			icon = new PIXI.Sprite.fromFrame('opt-in-popup-icon.png');
			icon.position.set(Absolute.Coords.x(30), Absolute.Coords.y(30));
			icon.width = Absolute.Coords.x(135);
			icon.height = Absolute.Coords.y(160);
			this.icon = icon;
			this.titleFontSize = 43;
			var titleStyle = {
				font: Absolute.ScreenMetrics.getResScale() * this.titleFontSize + "px Arial",
				fontFamily: 'segoe',
				fill: '#000000',
				tint: 0xffffff,
				align: 'left'
			};
			title = new PIXI.Text(Absolute.StringManager(dialogHeadline), titleStyle);
			title.position.set(Absolute.Coords.x(195), Absolute.Coords.y(20));
			this.title = title;
			this.bodyFontSize = 28;
			var bodyStyle = {
				font: Absolute.ScreenMetrics.getResScale() * this.bodyFontSize + "px Arial",
				fontFamily: 'segoe',
				fill: '#000000',
				align: 'left',
				wordWrap: true,
				wordWrapWidth: Absolute.Coords.x(750)
			};
			body = new PIXI.Text(Absolute.StringManager(dialogBody), bodyStyle);
			body.position.set(Absolute.Coords.x(195), Absolute.Coords.y(120));
			this.body = body;
			var wildButton = this.drawButton(0xd7ac38, 0x93782f, 0xc8a138, '#ffffff',
				Absolute.StringManager('buttons.wildCard'), function () {
					onClose('wildCard');
				});
			var extraButton = this.drawButton(0xd7ac38, 0x93782f, 0xc8a138, '#ffffff',
				Absolute.StringManager('buttons.extraDeal'), function () {
					onClose('extraDeal');
				});
			var noButton = this.drawButton(0xe7e7e5, 0xb0b0b0, 0xebebea, '#000000',
				Absolute.StringManager('buttons.noThanks'), function () {
					onClose('no');
				});
			this.popupContainer.addChild(graphics);
			this.popupContainer.addChild(popupBkg);
			this.popupContainer.addChild(icon);
			this.popupContainer.addChild(title);
			this.popupContainer.addChild(body);
			this.popupContainer.addChild(wildButton);
			this.popupContainer.addChild(extraButton);
			this.popupContainer.addChild(noButton);
			this.addChild(this.popupContainer);
			this.popupContainer.visible = true;
			wildButton.position.set(Absolute.Coords.y(25), Absolute.Coords.y(270));
			extraButton.position.set(Absolute.Coords.y(350), Absolute.Coords.y(270));
			noButton.position.set(Absolute.Coords.y(675), Absolute.Coords.y(270));
			this.initForceScaleSprite();
			ScaleManager.addElement(this, {scaleChangeSource: 'Full'});
		};

		BoostDialog.prototype.initForceScaleSprite = function () {
			this.forceScaleSprite = PIXI.Sprite.fromFrame("Buttons/SubMenuBack/SubMenuBack-Up.png");
			this.forceOffsetX = Absolute.Coords.x(20);
			this.forceOffsetY = Absolute.Coords.y(20);
			this.forceScaleSprite.width = Absolute.Coords.x(835);
			this.forceScaleSprite.height = Absolute.Coords.y(365);
			this.forceScaleSprite.alpha = 0;
			this.addChild(this.forceScaleSprite);
		};

		BoostDialog.prototype.handleResize = function () {
			if (ScaleManager.scaleFactorX <= 0.35) {
				this.changeToSmallLayout('small');
			} else {
				this.changeToLargeLayout('large');
			}
			if (this.parent) this.updateTransform();
			var oldScaleX = this.scale.x, oldScaleY = this.scale.y;
			this.scale.set(1, 1);
			var initialWidth = this.width, initialHeight = this.height;
			this.scale.set(oldScaleX, oldScaleY);
			var screenScaleX = Absolute.Coords.x(1920) / ScaleManager.width,
				screenScaleY = Absolute.Coords.y(1080) / ScaleManager.height,
				roomWidth = ScaleManager.width, roomHeight = ScaleManager.height;
			this.width = initialWidth * screenScaleX;
			this.height = initialHeight * screenScaleY;
			var realWidth = this.width / screenScaleX, realHeight = this.height / screenScaleY;
			var widthToShow = initialWidth, heightToShow = initialHeight;
			var tookCare = false;
			if (realWidth > roomWidth) {
				this.width = Absolute.Coords.x(1920);
				var delta = roomWidth / widthToShow;
				this.height = ((initialHeight * screenScaleY) * delta);
				if ((this.height / screenScaleY) > roomHeight) {
					this.height = Absolute.Coords.y(1080);
					var delta = roomHeight / heightToShow;
					this.width = ((initialWidth * screenScaleX) * delta);
				}
				tookCare = true;
			}
			if (!tookCare && (realHeight > roomHeight)) {
				this.height = Absolute.Coords.y(1080);
				var delta = roomHeight / heightToShow;
				this.width = ((initialWidth * screenScaleX) * delta);
				if ((this.width / screenScaleX) > roomWidth) {
					this.width = Absolute.Coords.x(1920);
					var delta = roomWidth / widthToShow;
					this.height = ((initialHeight * screenScaleY) * delta);
				}
			}
			this.x = (Absolute.Coords.x(1920) * .5) - (this.width / 2) + this.forceOffsetX;
			this.y = (Absolute.Coords.y(1080) * .5) - (this.height / 2) + this.forceOffsetY;
		};

		BoostDialog.prototype.changeToSmallLayout = function (layoutType) {
			if (this.layoutType === layoutType) return;
			this.icon.visible = false;
			this.title.position.set(this.icon.x, this.icon.y);
			this.title.style.font = Absolute.ScreenMetrics.getResScale() * (this.titleFontSize + 7) + "px Arial";
			this.title.updateText();
			this.body.x = this.icon.x;
			this.body.style.font = Absolute.ScreenMetrics.getResScale() * (this.bodyFontSize + 7) + "px Arial";
			this.body.style.wordWrapWidth = Absolute.Coords.x(750);
			this.body.updateText();
			this.layoutType = layoutType;
		};

		BoostDialog.prototype.changeToLargeLayout = function (layoutType) {
			if (this.layoutType === layoutType) return;
			this.icon.visible = true;
			this.title.position.set(Absolute.Coords.x(195), Absolute.Coords.y(20));
			this.title.style.font = Absolute.ScreenMetrics.getResScale() * this.titleFontSize + "px Arial";
			this.title.updateText();
			this.body.position.set(Absolute.Coords.x(195), Absolute.Coords.y(100));
			this.body.style.font = Absolute.ScreenMetrics.getResScale() * this.bodyFontSize + "px Arial";
			this.body.style.wordWrapWidth = Absolute.Coords.x(600);
			this.body.updateText();
			this.layoutType = layoutType;
		};

		BoostDialog.prototype.buildOverlay = function () {
			this.screenOverlay = new PIXI.Graphics();
			this.screenOverlay.beginFill(0x000000);
			this.screenOverlay.drawRect(0, 0, Absolute.Coords.x(10000), Absolute.Coords.y(10000));
			this.screenOverlay.alpha = 0.8;
			this.screenOverlay.interactive = true;
			this.bindScreenOverlayInteractions();
			this.parentToAdd.addChild(this.screenOverlay)
		};

		BoostDialog.prototype.bindScreenOverlayInteractions = function () {
			this.screenOverlay.mouseover = function (evt) {
			};
			this.screenOverlay.mouseout = function (evt) {
			};
			this.screenOverlay.mousedown = function (evt) {
			};
			this.screenOverlay.mouseup = function (evt) {
			};
			this.screenOverlay.touchstart = function (evt) {
			};
			this.screenOverlay.touchend = function (evt) {
			};
			this.screenOverlay.touchendoutside = function (evt) {
			};
		};

		BoostDialog.prototype.close = function () {
			this.parentToAdd.removeChild(this.screenOverlay);
			this.parentToAdd.removeChild(this);
			ScaleManager.removeElement(this);
		};

		BoostDialog.prototype.drawButton = function (upBgColor, downBgColor, overBgColor, textColor, text, doAction) {
			var graphics = new PIXI.Graphics(),
				text = new PIXI.Text(text, {
					font: Absolute.ScreenMetrics.getResScale() * 21 + "px Arial",
					fontFamily: 'segoe',
					fill: textColor,
					align: 'left'
				});
			var showAsUp = function () {
				graphics.clear();
				graphics.beginFill(upBgColor);
				graphics.drawRect(0, 0, Absolute.Coords.x(300), Absolute.Coords.y(60));
				graphics.endFill();
			};
			var showAsDown = function () {
				graphics.clear();
				graphics.beginFill(downBgColor);
				graphics.drawRect(0, 0, Absolute.Coords.x(300), Absolute.Coords.y(60));
				graphics.endFill();
			};
			var showAsOver = function () {
				graphics.clear();
				graphics.beginFill(overBgColor);
				graphics.drawRect(0, 0, Absolute.Coords.x(300), Absolute.Coords.y(60));
				graphics.endFill();
			};
			showAsUp();
			graphics.interactive = true;
			graphics.buttonMode = true;
			graphics.addChild(text);
			text.anchor.set(.5, .5);
			text.position.set(Absolute.Coords.x(150), Absolute.Coords.y(30));
			graphics.touchstart = function (evt) {
				showAsDown();
			};
			graphics.touchend = function (evt) {
				showAsUp();
				doAction();
			};
			graphics.touchendoutside = function (evt) {
				showAsUp();
			};
			graphics.mouseover = function (evt) {
				showAsOver();
			};
			graphics.mouseout = function (evt) {
				showAsUp()
			};
			graphics.mousedown = function (evt) {
				showAsDown()
			}.bind(this);
			graphics.mouseup = function (evt) {
				showAsUp();
				doAction();
			}.bind(this);
			return graphics;
		};

		return BoostDialog;
	});

